module.exports = __webpack_public_path__ + "static/media/willy-dade.5e8a8424.jpg";